/* Subtle scroll reveal — fade and rise. Nothing moves for visitors who have
   asked for reduced motion; they simply see the content already in place. */
(function () {
  'use strict';
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var SEL = '.n-section > .n-wrap > *, .n-slide__content, .n-review, .n-card';

  function observe() {
    var els = document.querySelectorAll(SEL);
    if (!('IntersectionObserver' in window)) return;

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        e.target.classList.add('is-in');
        io.unobserve(e.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.06 });

    els.forEach(function (el, n) {
      if (el.dataset.revealed) return;
      el.dataset.revealed = '1';
      el.classList.add('n-reveal');
      el.style.transitionDelay = Math.min(n % 4, 3) * 70 + 'ms';
      io.observe(el);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', observe);
  else observe();
  document.addEventListener('shopify:section:load', observe);
})();
